<template>
  <div class="container">
    <!-- <img
      :src="image"
      style="cursor: pointer;"
      :class="
        $vuetify.breakpoint.smAndDown ? 'migration-img-mobile' : 'migration-img'
      "
      @click="goToJogoDeOuro"
    /> -->
  </div>
</template>

<script>
export default {
  name: "V3Migration",
  //Matando os banners
  computed: {
    // image() {
    //   const mapDomainsToImages = {
    //     a3bet: "./a3bet.png",
    //     betclub7: "./betclub7.png",
    //     betpremier: "./premierbet.png",
    //     sportshowpix: "./sportshowpix.png",
    //     chutaco: "./chutaco.png",
    //     bet24hs: "./bet24hs.png",
    //     apostamaster: "./apostamaster.png",
    //     betgol: "./betgol.png",
    //     attack: "./attack.png",
    //     betpix: "./betpix.png",
    //     pixbrasil: "./pixbrasil.png",
    //     placarbets: "./placarbets.png",
    //     nbet91: "./nbet91.png",
    //     betgol777: "./betgol777.png",
    //     trevosports: "./trevosports.png",
    //     elitexbetnet: "./elitexbetnet.png",
    //     imperialbetcom: "./imperialbetcom.png",
    //     "18kbetonline": "./18kbetonline.png",
    //     sbet355: "./sbet355.png",
    //     betnaveia: "./betnaveia.png",
    //     recpix: "./recpix.png",
    //     streetbet: "./streetbet.png",
    //     sportebet: "./sportebet.png",
    //     soccer888: "./soccer888.png",
    //     nordestefutebol: "./nordestefutebol.png",
    //   };

    //   const images = require.context("./");
    //   return images(mapDomainsToImages[this.$domain()]);
    // },
  },

  methods: {
    goToJogoDeOuro() {
      if (this.$domain() === "18kbetonline") {
        window.location = "https://go.aff.jogodeouro.bet/1x2oyqq1";
      } else {
        window.location = "https://jogodeouro.bet/pt/sports#/overview";
      }
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
}

.migration-img-mobile {
  margin: auto;
  height: auto;
  width: 100%;
}

.migration-img {
  margin: auto;
  height: auto;
  max-width: 600px;
}
</style>
